export default __webpack_public_path__ + "6eb52fa7d1fdf67a6b63bdb5b63d00b7.png";